import React, { Component } from 'react';
import Header from './header';
import Footer from './footer';
import Page from './page';
import { withRouter } from 'react-router-dom';
import HomeSubHeader from './homeSubHeader';
class Home extends Component {
    constructor(props){
        super(props)
    }

    componentDidMount(){
        var page = this;
    }

    render() {
        var page = this;
        return (
            <div className="d-flex flex-row flex-column-fluid page">
                <div id="kt_wrapper" className="d-flex flex-column flex-row-fluid wrapper">
                    <Header loginSuccess={page.props.loginSuccess} sessionLogout={page.props.sessionLogout}>
                        {/* <HomeSubHeader/> */}
                    </Header>
                    <Page></Page>
                    <Footer></Footer>
                </div>
            </div>
        );
    }
}
export default withRouter(Home);